/*
 * @Description:
 * @Author: doris_xu
 * @Date: 2023-05-29 10:59:22
 * @LastEditTime: 2025-11-24 14:32:37
 */
/* eslint-disable */
/* tslint:disable */

import footerLogo from '../../images/footerLogo1.png'
import fwzx from '../../images/fwzx_qrcode.jpg'
import gxkf from '../../images/gxkf_qrcode.jpg'
import wxQr from '../../images/wx_qrcode.png'

import { Layout } from 'antd'

const Footer = () => {
  return (
    <Layout.Footer className="footer">
      <div className="footer-container">
        <div className="footer-info">
          {/*<div className="info-left">
            <div className="info-logo"></div>
            <div className="info-text">
              关于一些企业需求工艺开发， 自动化生产简洁等等，
              食品标准等等关于一些企业需求业需求工艺开发， 自动化生产简洁等等，
              食品标准业需工艺开发...
            </div>
          </div>*/}
          <div className="info-right">
            <div className="info-unit">
              <img src={footerLogo} />
            </div>
            <div
              className="info-nav"
              style={{
                marginLeft: '64px',
                minWidth: '545px',
                maxWidth: '600px',
              }}>
              <div className="top">
                首届“龙知交”高价值专利运营大赛
              </div>
              <div className="left" style={{ width: 'unset' }}>
                <div className="footer-title">联系人</div>
                <div
                  className="footer-subTitle"
                  style={{ paddingLeft: '20px' }}>
                  <span>陈女士 &nbsp;&nbsp;0451-58894187</span>
                  <span style={{ paddingLeft: '20px' }}>王先生 &nbsp;&nbsp;0451-58894183</span>
                  {/* <span style={{ marginLeft: '40px' }}>
                    <a rel="nofollow" href="mailto:lixiaobai@stte.com">
                      lixiaobai@stte.com
                    </a>
                  </span> */}
                </div>
              </div>
              <div
                className="left"
                style={{ width: 'unset', marginTop: '0px' }}>
                <div className="footer-title">地址</div>
                <div
                  className="footer-subTitle"
                  style={{ paddingLeft: '20px' }}>
                  <span>黑龙江省哈尔滨市松北区世茂大道66号</span>
                </div>
              </div>
            </div>

            <div className="info-nav link" style={{ flexWrap: 'nowrap' }}>
              <div className="right">
                {/* <div>
                  <img src={enQr} />
                  <p>合作意向请入</p>
                </div> */}
                <div>
                  <img src={wxQr} />
                  <p>黑龙江科技成果和知识产权交易平台</p>
                </div>
                {/* <div>
                  <img src={gxkf} />
                  <p>高校科技发展中心</p>
                </div>
                <div>
                  <img src={fwzx} />
                  <p>知识产权服务中心</p>
                </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className="footer-text">
        Copyright ©2025 上技所数字科技（上海）有限公司 版权所有 ICP证：
        <a href="https://beian.miit.gov.cn/" target={'_blank'}>
          黑ICP备2023012917号-1
        </a>
        &nbsp;&nbsp;版本：1.0.0
      </div> */}
    </Layout.Footer>
  )
}

export default Footer
